{
  "selectAsField": "Chọn \"{value}\" làm {fieldName}",
  "typeToSearchField": "Nhập để tìm kiếm {fieldName}",
  "licenseFieldLabel": "Chọn Biển số xe (ví dụ: 215BG2)",
  "licenseFieldName": "Biển số xe",
  "licensePlaceholder": "Tìm kiếm theo biển số xe",
  "dotFieldLabel": "Chọn Số DOT",
  "dotFieldName": "Số DOT",
  "dotPlaceholder": "Tìm kiếm theo số DOT"
}
